import React, { useState } from 'react'
import { Collapse, Switch, Typography } from 'antd'
import styled from 'styled-components/macro'
import { ReactMultiEmail, isEmail } from 'react-multi-email'
import { StockQuietButton } from 'src/components/stock/StockPageChrome'

const { Text } = Typography
const { Panel } = Collapse

const StockSettingsPanel = ({
  autoEmailEnabled = false,
  recipients = [],
  onChange = () => {},
}) => {
  const safeRecipients = Array.isArray(recipients) ? recipients : []
  const [showSaved, setShowSaved] = useState(false)

  const handleManualSave = () => {
    onChange({
      stockTakeAutoEmailEnabled: autoEmailEnabled,
      stockTakeReportEmails: safeRecipients,
    })
    setShowSaved(true)
    setTimeout(() => setShowSaved(false), 1800)
  }

  return (
    <Collapse
      data-testid='stock-take-variance-email-accordion'
      style={{ marginBottom: 8 }}
      defaultActiveKey={[]}
    >
      <Panel header='Variance report email' key='variance-report-email'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}
        >
          <Text strong>
            Automatically email variance report when stock take is locked
          </Text>
          <Switch
            checked={autoEmailEnabled}
            onChange={checked =>
              onChange({
                stockTakeAutoEmailEnabled: checked,
                stockTakeReportEmails: recipients,
              })
            }
          />
        </div>

        <EmailInputLabel>Email Recipients</EmailInputLabel>
        <StyledReactMultiEmail
          placeholder='Enter one or more email addresses'
          emails={safeRecipients}
          onChange={emails =>
            onChange({
              stockTakeAutoEmailEnabled: autoEmailEnabled,
              stockTakeReportEmails: emails,
            })
          }
          validateEmail={email => isEmail(email)}
          getLabel={(email, index, removeEmail) => (
            <EmailTag data-tag key={index}>
              {email}
              <span data-tag-handle onClick={() => removeEmail(index)}>
                ×
              </span>
            </EmailTag>
          )}
        />

        <Text type='secondary' style={{ display: 'block', marginTop: 8 }}>
          Add one or more email addresses to automatically receive the variance
          report whenever a stock take is locked.
        </Text>
        <SaveRow>
          {showSaved ? (
            <SavedIndicator>✓ Saved</SavedIndicator>
          ) : (
            <StockQuietButton type='button' onClick={handleManualSave}>
              Save email
            </StockQuietButton>
          )}
        </SaveRow>
      </Panel>
    </Collapse>
  )
}

const EmailInputLabel = styled.label`
  display: inline-block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
`

const StyledReactMultiEmail = styled(ReactMultiEmail)`
  min-height: 40px;
`

const EmailTag = styled.div`
  background-color: ${({ theme }) => theme.colours.lettuceGreen} !important;
`

const SaveRow = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
`

const SavedIndicator = styled.div`
  padding: 6px 12px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  color: #52c41a;
  font-weight: 500;
  font-size: 13px;
`

export default StockSettingsPanel
